<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.financialInformation.achievementSales.$invalid 
      || $v.financialInformation.achievementGrossProfit.$invalid 
      || $v.financialInformation.achievementOrdinaryProfit.$invalid
      || $v.financialInformation.resultMemo.$invalid 
      || $v.financialInformation.actionMemo.$invalid">
      <div v-if="$v.financialInformation.achievementSales.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">売上（実績）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.financialInformation.achievementSales.$invalid && !$v.financialInformation.achievementSales.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.financialInformation.achievementSales.$invalid && $v.financialInformation.achievementSales.numeric && !$v.financialInformation.achievementSales.between" validation="between" valueMin="0" valueMax="9999999999"/>
      </div>
      <div v-if="$v.financialInformation.achievementGrossProfit.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">粗利（実績）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.financialInformation.achievementGrossProfit.$invalid && !$v.financialInformation.achievementGrossProfit.integer" validation="integer"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.financialInformation.achievementGrossProfit.$invalid && $v.financialInformation.achievementGrossProfit.integer && !$v.financialInformation.achievementGrossProfit.between" validation="between" valueMin="-9999999999" valueMax="9999999999"/>
      </div>
      <div v-if="$v.financialInformation.achievementOrdinaryProfit.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">経常利益（実績）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.financialInformation.achievementOrdinaryProfit.$invalid && !$v.financialInformation.achievementOrdinaryProfit.integer" validation="integer"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.financialInformation.achievementOrdinaryProfit.$invalid && $v.financialInformation.achievementOrdinaryProfit.integer && !$v.financialInformation.achievementOrdinaryProfit.between" validation="between" valueMin="-9999999999" valueMax="9999999999"/>
      </div>
      <div v-if="$v.financialInformation.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.financialInformation.resultMemo.$invalid && !$v.financialInformation.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.financialInformation.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.financialInformation.actionMemo.$invalid && !$v.financialInformation.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">財務情報（売上・粗利・経常利益）</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>売上高</th>
              <td>
                <div class="human-capitalt-data-table__input is-bold is-important is-extra-wide">
                  <TextBox v-model.trim="$v.financialInformation.$model.achievementSales" type="text" name="financialInformation.achievementSales" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">千円</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>粗利</th>
              <td>
                <div class="human-capitalt-data-table__input is-bold is-important is-extra-wide">
                  <TextBox v-model.trim="$v.financialInformation.$model.achievementGrossProfit" type="text" name="financialInformation.achievementGrossProfit" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">千円</span>
                </div>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>経営利益</th>
              <td>
                <div class="human-capitalt-data-table__input is-bold is-important is-extra-wide">
                  <TextBox v-model.trim="$v.financialInformation.$model.achievementOrdinaryProfit" type="text" name="financialInformation.achievementOrdinaryProfit" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">千円</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->
    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="financialInformation.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(financialInformation.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="financialInformation.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { integer, numeric, between, maxLength } from 'vuelidate/lib/validators';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
  },
  props: {
    // 表示年度の財務情報データ
    financialInformation: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
    }
  },
  validations: {
    financialInformation: {
      achievementSales : { numeric, between: between(0,9999999999) },         // 売上（実績）
      achievementGrossProfit : { integer, between: between(-9999999999,9999999999) },   // 粗利（実績）
      achievementOrdinaryProfit : { integer, between: between(-9999999999,9999999999) },// 経常利益（実績）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    financialInformation() {
      this.inputFinancialInformation();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputFinancialInformation() {
      this.$emit("change-financial-info", {
        financialInformation: this.financialInformation,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
        }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
